// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.narrator.dev.jolifish.eu/api/back/app',
  firebaseConfig: {
    apiKey: "AIzaSyDBPA8pTUq01OfsZwXymsmn3lQTsZrtzjY",
    authDomain: "narratheque.firebaseapp.com",
    projectId: "narratheque",
    storageBucket: "narratheque.firebasestorage.app",
    messagingSenderId: "715983646421",
    appId: "1:715983646421:web:84a404adbaa77db3a8fc5c",
    measurementId: "G-ZJRYF46F93"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
